import { OrganizationTraits, ProjectPrivacy } from '@neptune/shared/core-organizations-domain';
import { isProjectPrivacyAvailable } from '@neptune/shared/core-project-business-logic';

export const canCreatePrivateProjects = (organizationTraits: OrganizationTraits): boolean => {
  return isProjectPrivacyAvailable(ProjectPrivacy.private, organizationTraits);
};
